function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useMemo, useEffect, useContext } from 'react';
import { FilterBadges } from '../../../common/Filter';
import { filterContext } from '../../../common/FilterProvider';
import { useGetQualificationsByIds } from '../../../../api/QualificationAPI';
export function LongitudinalFilterBadges(_param) {
    var isDisabled = _param.isDisabled, _param_onTagClicked = _param.onTagClicked, onTagClicked = _param_onTagClicked === void 0 ? function() {
    //
    } : _param_onTagClicked, rest = _object_without_properties(_param, [
        "isDisabled",
        "onTagClicked"
    ]);
    var context = useContext(filterContext);
    var filterValues = context.filterValues, onFilterItemLabelChange = context.onFilterItemLabelChange;
    var qualificationIds = Object.keys(filterValues).map(function(qId) {
        return parseInt(qId);
    });
    var queries = useGetQualificationsByIds(qualificationIds, true, true);
    var isLoading = queries.some(function(query) {
        return query.isLoading;
    });
    var _useMemo = useMemo(function() {
        if (!isLoading) {
            var qualificationsByQuestionId = {};
            var filterNames = queries.reduce(function(acc, query) {
                var qualification = query.data.data.data;
                acc[qualification.attributes.question_id] = qualification.attributes.name;
                qualificationsByQuestionId[qualification.attributes.question_id] = qualification;
                return acc;
            }, {});
            return {
                filterNames: filterNames,
                qualificationsByQuestionId: qualificationsByQuestionId
            };
        }
        return {
            filterNames: {},
            qualificationsById: {}
        };
    }, [
        isLoading,
        queries
    ]), filterNames = _useMemo.filterNames, qualificationsByQuestionId = _useMemo.qualificationsByQuestionId;
    useEffect(function() {
        if (!isLoading) {
            Object.entries(filterValues).forEach(function(param) {
                var _$_param = _sliced_to_array(param, 2), qId = _$_param[0], values = _$_param[1];
                var qualification = qualificationsByQuestionId[qId];
                var answers = qualification.attributes.custom_qualification_answers || qualification.attributes.qualification_answers;
                if (answers) {
                    var answersByPreCode = answers.reduce(function(acc, answer) {
                        acc[answer.attributes.pre_code] = answer;
                        return acc;
                    }, {});
                    var labels = values.map(function(filterValue) {
                        var _answersByPreCode_filterValue_attributes;
                        return (_answersByPreCode_filterValue_attributes = answersByPreCode[filterValue].attributes) === null || _answersByPreCode_filterValue_attributes === void 0 ? void 0 : _answersByPreCode_filterValue_attributes.option_text;
                    }).join(', ');
                    onFilterItemLabelChange(qId, labels);
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(filterValues),
        isLoading
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isLoading && /*#__PURE__*/ React.createElement(FilterBadges, _object_spread_props(_object_spread({}, rest), {
        filterNames: filterNames,
        onTagClicked: onTagClicked,
        isDisabled: isDisabled
    })));
}
